// Display metadata only; no arithmetic, activation switch or approval flag.
export function icRepeatabilityPreview(type: string, method: string, acceptance: string): { lower: string | null; upper: string } | null {
  if (type !== 'REPEATABILITY' || !['STD_DEV', 'RANGE'].includes(method) || !['MAX', 'RANGE'].includes(acceptance)) return null;
  const sd = method === 'STD_DEV';
  return {
    lower: acceptance === 'RANGE' ? (sd ? 'حد پایین انحراف معیار' : 'حد پایین دامنه قرائت‌ها') : null,
    upper: acceptance === 'MAX'
      ? (sd ? 'حداکثر انحراف معیار مجاز' : 'حداکثر دامنه قرائت‌ها')
      : (sd ? 'حد بالای انحراف معیار' : 'حد بالای دامنه قرائت‌ها')
  };
}
